export const formatHistoryTitlePrefix = (
    roomIndex?: number | null,
    roomCabNumber?: number | null
): string => {
    const cabNum = roomCabNumber != null ? String(roomCabNumber) : null;
    const displayRoomIndex = roomIndex != null ? String(roomIndex + 1) : null;
    if (displayRoomIndex != null && cabNum != null) {
        return `[${displayRoomIndex}-${cabNum}] `;
    }
    // No cab number yet — use ellipsis so the title slot is reserved and the
    // regex in _flushTitleUpdateQueue can patch it in once the server responds.
    if (displayRoomIndex != null) {
        return `[${displayRoomIndex}-...] `;
    }
    if (cabNum != null) {
        return `[${cabNum}] `;
    }
    return '';
};
